import { render, staticRenderFns } from "./AboutImg.vue?vue&type=template&id=735f9e36&scoped=true&"
import script from "./AboutImg.vue?vue&type=script&lang=js&"
export * from "./AboutImg.vue?vue&type=script&lang=js&"
import style0 from "./AboutImg.vue?vue&type=style&index=0&id=735f9e36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f9e36",
  null
  
)

export default component.exports